import { useRef } from 'react';

import { Button, Center, Flex, Spinner, Text, useBoolean } from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import { ArrowLeftOutline, EditOutline } from '@aslanpay/portal-common-lib';

import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';
import { MyProfileEdit, MyProfileView } from 'app/components/Admins/MyProfile';

import useAuthContext from 'app/hooks/useAuthContext';
import useFetchIndividual from 'app/hooks/useFetchIndividual';
import useFetchCompany from 'app/hooks/useFetchCompany';

import { getBlankPath } from 'app/utils/routes';

function MyProfile() {
  const submitButtonRef = useRef<HTMLDivElement>(null);

  const { user } = useAuthContext();

  const navigate = useNavigate();

  const { data: admin, isInitialLoading: isLoadingAdmin } = useFetchIndividual(user?.id || '');
  const { data: company } = useFetchCompany(admin?.companyId);

  const [editMode, setEditMode] = useBoolean();

  return (
    <AuthenticatedPageWrapper title="My profile">
      {isLoadingAdmin ? (
        <Center width="full" height="full" flexGrow={1}>
          <Spinner color="brand.purple" size="xl" mb="50px" />
        </Center>
      ) : (
        <>
          <Button
            my="10px"
            alignSelf="flex-start"
            size="sm"
            variant="link"
            leftIcon={<ArrowLeftOutline boxSize="20px" />}
            onClick={() => navigate(getBlankPath())}
          >
            Back
          </Button>
          <Flex gap="20px" align="flex-start" justify="space-between" ref={submitButtonRef}>
            <Text as="h2" textStyle="h2" color="brand.darkPurple">
              My profile
            </Text>
            {!editMode && (
              <Flex gap="20px">
                <Button
                  leftIcon={<EditOutline boxSize="20px" />}
                  size="sm"
                  onClick={setEditMode.on}
                >
                  Edit
                </Button>
              </Flex>
            )}
          </Flex>

          {editMode ? (
            <MyProfileEdit
              ref={submitButtonRef}
              admin={admin}
              company={company}
              onCloseEditMode={setEditMode.off}
            />
          ) : (
            <MyProfileView admin={admin} company={company} />
          )}
        </>
      )}
    </AuthenticatedPageWrapper>
  );
}

export default MyProfile;
